var _g, _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMarkerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 29,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5241,
    cy: 39.5556,
    rx: 14.2936,
    ry: 5.95551,
    fill: "#151B26"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0411 0.510986C9.81498 0.510986 2.9375 8.61227 2.9375 17.9712C2.9375 29.839 19.0411 43.4898 19.0411 43.4898C19.0411 43.4898 35.1451 29.839 35.1451 17.9712C35.1451 8.73817 28.2672 0.510986 19.0411 0.510986ZM19.0411 24.6868C14.9651 24.6868 11.6596 21.3787 11.6596 17.2996C11.6596 13.2201 14.9651 9.91249 19.0411 9.91249C23.118 9.91249 26.4235 13.2197 26.4235 17.2996C26.4235 21.3783 23.118 24.6868 19.0411 24.6868Z",
    fill: "#151B26"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0436,
    cy: 18.3832,
    r: 9.38341,
    fill: "#5C6473"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.230469,
    y: 29.6001,
    width: 36.5872,
    height: 19.911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMarkerBlack);
export default __webpack_public_path__ + "static/media/pin-marker-black.4eed092be970ca97b359d8dee283f80d.svg";
export { ForwardRef as ReactComponent };